var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home safe-area-inset-bottom" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/new_pages/market1.jpg"),
          alt: "part 1"
        }
      }),
      _c("div", { attrs: { id: "willingForm1" } }),
      _c("img", {
        attrs: {
          src: require("@/assets/images/new_pages/market2.jpg"),
          alt: "part 2"
        }
      }),
      _c("div", { attrs: { id: "willingForm2" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }